import { useCallback, useContext, useEffect } from 'react';

import { useRouter } from 'next/router';

import { AuthContext } from '@arrived/auth';
import { Loading, Stack } from '@arrived/bricks';
import { ROUTES } from '@arrived/common';
import { PropertyDetails } from '@arrived/components';
import { CONFIG } from '@arrived/config';
import { AssetType } from '@arrived/models';
import { useOfferingQuery } from '@arrived/queries';

import { useDeviceTypePath } from '../../hooks/useDeviceType';
import { PublicFooter } from '../footer';
import { OfferingTransactSharesButton } from './OfferingTransactSharesButton';
import { PropertySlideshowThumbnail } from './PropertySlideshowThumbnail';

export const PropertyDetailsStandalone = () => {
  const router = useRouter();
  const { isAuthenticated } = useContext(AuthContext);
  const deviceTypeBackPath = useDeviceTypePath();
  const offeringState = useOfferingQuery(router.query.shortName as string);

  const handleOnBackButtonClick = () => {
    router.replace(deviceTypeBackPath(ROUTES.properties.base), ROUTES.properties.base, {
      scroll: false,
    });
  };

  // TODO: Can be improved in the future to handle this redirect elsewhere up the tree
  useEffect(() => {
    if (isAuthenticated) {
      router.replace(CONFIG.appRoot + router.asPath);
    }
  }, [isAuthenticated]);

  /**
   * TODO: STN change needed for cross platform
   * If we are not authenticated, we cannot see STNs
   */
  useEffect(() => {
    if (offeringState.data?.assetType === AssetType.STN && !isAuthenticated) {
      router.replace(CONFIG.publicAppRoot + ROUTES.properties.base);
    }
  }, [isAuthenticated, offeringState?.data]);

  const productWidgetButtonOnPress = useCallback(() => router.push(ROUTES.logIn), [router]);

  if (offeringState.isLoading || !offeringState.data) {
    return (
      <Stack flex={1} alignItems="center" justifyContent="center">
        <Loading.Indicator variant="colored" />
      </Stack>
    );
  }

  return (
    <PropertyDetails
      offering={offeringState.data}
      propertyActionButton={<OfferingTransactSharesButton offering={offeringState.data} />}
      footer={<PublicFooter issuerId={offeringState.data?.issuer.id} />}
      handleOnBackButtonClick={handleOnBackButtonClick}
      PropertyThumbnailComponent={PropertySlideshowThumbnail}
      productWidgetButtonOnPress={productWidgetButtonOnPress}
    />
  );
};
